<template>
  <v-row>
    <v-col
      cols="12"
      lg="3"
    >
      <naj-input
        :type-id="formFieldType.selectbox"
        :label="local.lawsuitDetails.court"
        :value="courtId"
        :items="closestCourts"
        :disabled="disabled"
        item-value="id"
        item-text="name"
        :validates="'required'"
        @change="updateCourtId"
      ></naj-input>
      <span
        v-if="caseData.isRelatedToCorona"
        class="user-attention"
      >
        {{ local.lawsuitDetails.coronaAttention }}
      </span>
    </v-col>
    <v-col
      cols="12"
      lg="2"
    >
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <naj-input
        :type-id="formFieldType.checkbox"
        :value.sync="isAnotherCourtSelected"
        :label="local.lawsuitDetails.isAnotherCourtSelected"
        :disabled="disabled"
        @change="selectAnotherCourtChanged"
      ></naj-input>
    </v-col>
    <v-col
      cols="12"
      lg="4"
    >
      <naj-input
        :type-id="formFieldType.text"
        :value.sync="anotherCourtSelectedReason"
        :label="local.lawsuitDetails.anotherCourtSelectedReason"
        :disabled="!isAnotherCourtSelected || disabled"
        :validates="`${isAnotherCourtSelected ? 'required|' : ''}arabic_letters|max:200`"
      ></naj-input>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  inject: ['$validator'],
  props: ['courtId', 'partiesInfo', 'disabled', 'handleGetCourtsInvoker', 'disableLocationSpecializationRule'],
  data() {
    return {
      closestCourts: [],
      isAnotherCourtSelected: null,
      anotherCourtSelectedReason: null,
    };
  },
  computed: { ...mapState({ caseData: state => state.lawsuitRequest.case }) },
  watch: {
    handleGetCourtsInvoker(invoker) {
      if (invoker)
        this.handleGetCourts(invoker, !!this.isAnotherCourtSelected);
    },
    isAnotherCourtSelected(value) {
      this.$set(this.caseData, 'isAnotherCourtSelected', value);
    },
    anotherCourtSelectedReason(value) {
      this.$set(this.caseData, 'anotherCourtSelectedReason', value);
    },
  },
  mounted() {
    this.isAnotherCourtSelected = this.caseData.isAnotherCourtSelected || null;
    this.anotherCourtSelectedReason = this.caseData.anotherCourtSelectedReason || null;
    this.handleGetCourts('mounted', !!this.isAnotherCourtSelected);
  },
  methods: {
    ...mapActions(['getPartiesClosestCourts']),
    handleGetCourts(invoker) {
      const caseTypeId = this.caseData.caseTypeId || null;
      const caseCategoryId = this.caseData.caseCategoryId || null;
      const caseClassificationId = this.caseData.caseClassificationIdNew || null;
      const accidentCityId = this.caseData.cityId || null;
      const disableLocationSpecializationRule = this.isAnotherCourtSelected || null;
      const isRelatedToCorona = this.caseData.isRelatedToCorona || null;
      if (caseTypeId && caseCategoryId && caseClassificationId && (this.partiesInfo || []).length) {
        const data = {
          invoker,
          caseTypeId,
          caseCategoryId,
          caseClassificationId,
          accidentCityId,
          isRelatedToCorona,
          disableLocationSpecializationRule,
          partiesInfo: this.partiesInfo,
          form: (this.caseData.forms || [])[0],
        };
        this.getPartiesClosestCourts(data)
          .then(({ data }) => {
            this.closestCourts = data.data;
            this.$emit('courtsRetrieved', this.closestCourts);
          });
      }
    },
    selectAnotherCourtChanged(value) {
      if (!value)
        this.anotherCourtSelectedReason = null;
      this.handleGetCourts('selectAnotherCourtChanged', !!this.isAnotherCourtSelected);
    },
    updateCourtId(courtId) {
      this.$emit('update:courtId', courtId);
      this.$emit('change', courtId);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-attention {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
